export const PolygonMainnet = {
    chainId: "0x89",
    rpcUrls: ["https://polygon-rpc.com/"],
    chainName: "Matic Mainnet",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18
    },
    blockExplorerUrls: ["https://polygonscan.com/"]
}

export const PolygonMumbai = {
    chainId: "0x13881",
    rpcUrls: [`https://polygon-mumbai.g.alchemy.com/v2/sdw5U7kfxpgf9vRsuv9xUKz1W91id3qb`],
    chainName: "Mumbai Testnet",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18
    },
    blockExplorerUrls: ["https://polygonscan.com/"]
}
